import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Gift, X } from "lucide-react";
import { api, referralCode, REF_KEY } from "@/lib/api";
import { scrollTo } from "@/components/Nav";

export default function ReferralBanner() {
  const [ref, setRef] = useState(null);
  useEffect(() => {
    const code = referralCode();
    if (!code || sessionStorage.getItem("rr_ref_banner_dismissed")) return;
    let stored = {};
    try { stored = JSON.parse(localStorage.getItem(REF_KEY) || "{}"); } catch { /* ignore */ }
    if (stored.first_name) { setRef({ code, ...stored }); return; }
    api.get(`/referrals/${code}`).then((r) => {
      localStorage.setItem(REF_KEY, JSON.stringify({ ...stored, ...r.data }));
      setRef({ code, ...r.data });
    }).catch(() => localStorage.removeItem(REF_KEY));
  }, []);

  const dismiss = () => { sessionStorage.setItem("rr_ref_banner_dismissed", "1"); setRef(null); };

  return (
    <AnimatePresence>
      {ref && (
        <motion.div initial={{ y: -40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -40, opacity: 0 }}
          className="fixed top-[72px] inset-x-0 z-40 px-3 sm:px-6 pointer-events-none" data-testid="referral-banner">
          <div className="max-w-3xl mx-auto pointer-events-auto bg-ink text-sand rounded-2xl shadow-2xl px-4 py-3 flex items-center gap-3 border border-gold/30">
            {ref.picture ? <img src={ref.picture} alt="" referrerPolicy="no-referrer" className="w-9 h-9 rounded-full ring-2 ring-gold shrink-0" /> : <span className="w-9 h-9 rounded-full bg-gold text-ink grid place-items-center shrink-0"><Gift size={16} /></span>}
            <p className="text-sm leading-snug flex-1">
              <span className="font-semibold" data-testid="referral-banner-name">Your friend {ref.first_name} sent you here</span>
              <span className="text-sand/70"> — book any ride, cab or tour and they earn a thank-you from us. Nothing extra for you.</span>
            </p>
            <button onClick={() => scrollTo("#tours")} className="hidden sm:inline-flex text-xs font-semibold bg-gold text-ink px-3.5 py-2 rounded-full hover:bg-sand transition-colors whitespace-nowrap" data-testid="referral-banner-cta">Book to support them</button>
            <button onClick={dismiss} aria-label="Dismiss" className="p-1.5 rounded-full text-sand/60 hover:text-sand hover:bg-sand/10" data-testid="referral-banner-dismiss"><X size={16} /></button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
